import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { industries } from '../../data/industries';
import { SectionHeading } from '../ui/SectionHeading';
export function IndustryDirectory() {
  return <section className="bg-white py-24 md:py-32" data-id="element-204" data-mp="vopdag4ebd2v">
      <div className="container-page" data-id="element-205" data-mp="10h8ml0w1vm1v">
        <SectionHeading kicker="Industry expertise" title="Sector knowledge that shortens the search." intro="Our consultants understand the regulatory, commercial and cultural realities of the sectors they serve." data-id="element-206" data-mp="10ia49o7kn6sk" />
        <ul className="mt-12 grid gap-px overflow-hidden rounded-lg border border-line bg-line sm:grid-cols-2 lg:grid-cols-4" data-id="element-207" data-mp="1efyoquxq8bx3">
          {industries.map(ind => {
          const Icon = ind.icon;
          return <li key={ind.slug} className="bg-white" data-id="element-208" data-mp="3g96c8rnhtzu2">
                <Link to={`/industries#${ind.slug}`} className="group flex h-full items-center gap-4 p-5 transition-colors duration-150 hover:bg-midnight focus-visible:bg-midnight" data-id="element-209" data-mp="3l6y09al0p1sz">
                  <Icon className="h-5 w-5 shrink-0 text-gold-700 transition-colors duration-150 group-hover:text-gold-300" aria-hidden="true" data-id="element-210" data-mp="1843kx8sysl1t" />
                  <span className="flex-1 text-[15px] font-medium text-ink transition-colors duration-150 group-hover:text-white" data-id="element-211" data-mp="133pchpngb939">{ind.name}</span>
                  <ArrowRightIcon className="h-4 w-4 text-muted opacity-0 transition-opacity duration-150 group-hover:text-gold-300 group-hover:opacity-100" aria-hidden="true" data-id="element-212" data-mp="1vuz6vpaqom15" />
                </Link>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}